export function capitalizeKeys(obj: any): any {
    if (Array.isArray(obj)) {
        return obj.map(capitalizeKeys);
    } else if (obj !== null && typeof obj === 'object') {
        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [
                key.charAt(0).toUpperCase() + key.slice(1),
                capitalizeKeys(value)
            ])
        );
    }
    return obj;
}